import * as d3 from 'd3'
import LineChart from './LineChart'
import Legend from './Legend';
const YoutubeViewsLineChart = ({data,selectedTopic, setSelectedTopic}) => {
  var margin = { top: 20, left: 80, bottom: 70, right: 20 };
   var width = 500 - margin.left - margin.right;
   var height = 500 - margin.top - margin.bottom;
 
   // turns dict into an array of dictionaries {topic:string values:[...]}
   var aggregated = Array.from(
     d3.rollup(
       data,
       (v) => d3.sum(v, (d) => d.video_count),
       (d) => d.topic,
       (d) => d.date,
     ),
     ([topic, dateMap]) => ({
       topic,
       values: Array.from(dateMap, ([date, total]) => ({
         date,
         video_count: total,
       })).sort((a, b) => a.date - b.date),
     }),
   );
   var x = d3
     .scaleUtc()
     .domain(d3.extent(data, (d) => d.date))
     .range([0, width]);
   const yMax = d3.max(aggregated, (topic) =>
     d3.max(topic.values, (d) => d.video_count),
   );
   console.log(aggregated);
   // Declare the line generator.
   const line = d3
     .line()
     .x((d) => x(d.date))
     .y((d) => y(d.video_count));
    
   var colorScale = d3.scaleOrdinal()
        .domain(data.map(d => d.topic))
        .range(["#C0392B","#1F3A5F", "#16A085" ])
   var y = d3.scaleLinear().domain([0, yMax]).range([height, 0]);
 
   return (
    <div>
     <h4 className="youtube-heading">Youtube Average Video Count by Topic Over Time</h4>
    <div>
    <LineChart aggregated={aggregated} width={width} height={height} margin={margin} line={line} xscale={x} yscale={y} colorscale={colorScale} selectedTopic={selectedTopic} setSelectedTopic={setSelectedTopic}/>
      
    </div>
   
    </div>
   );
}
export default YoutubeViewsLineChart;

